import { StyledPageHeader } from "./PageHeader.styled";

export default StyledPageHeader;